import { Component, OnInit } from '@angular/core';
import { UserDetailsComponent } from 'gung-standard';

@Component({
    selector: 'app-hl-display-user-details',
    templateUrl: './hl-display-user-details.component.html',
    styleUrls: ['./hl-display-user-details.component.css'],
    standalone: false
})
export class HlDisplayUserDetailsComponent extends UserDetailsComponent {}
